module.exports = __webpack_public_path__ + "img/ul.19102aee.svg";